import { useState } from "react";
import { useTranslation } from "react-i18next";

import { PageStatus, SkeletonBase } from "@unified-checkout/design-system";
import {
  BuildingColumns,
  CircleExclamation,
  TrashIcon
} from "@unified-checkout/design-system/icons/index";

import type { ISavedMerchantCard } from "@app/dashboard/types/innerLayout/bills/saved-merchant-card";

import { DeleteModal } from '../Modals/Delete';
import styles from './saved-merchant-card.module.scss';

export const SavedMerchantCard = ({
  savedMerchants,
  isSavedMerchantsPending,
  refetch
}: ISavedMerchantCard) => {
  const { t } = useTranslation()
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedMerchant, setSelectedMerchant] = useState<any>(null);

  const handleOpenDeleteModal = (merchant: any) => {
    setSelectedMerchant(merchant);
    setIsDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedMerchant(null);
  };

  if (isSavedMerchantsPending) {
    return (
      <div className={styles['cards']}>
        {Array.from({ length: 2 }).map((_, index) => (
          <div key={index} className={styles['cards__content']}>
            <SkeletonBase height="4rem" />
          </div>
        ))}
      </div>
    )
  }
  return (
    <>
      <div className={styles['cards']}>
        {savedMerchants.length === 0 ? (
          <div className={styles['cards__empty']}>
            <PageStatus
              status="error"
              icon={CircleExclamation}
              title={t('innerLayout.billsPage.savedBills.noSavedMerchants')}
              description={t('innerLayout.billsPage.savedBills.noSavedMerchantsDescription')}
            />
          </div>
        ) : (
          savedMerchants.map((card: any) => {
            return (
              <div key={card.merchant_id} className={styles['cards__content']}>
                <div className={styles['cards__content__info']}>
                  <div className={styles['cards__content__info__icon']}>
                    {BuildingColumns}
                  </div>

                  <div className={styles['cards__content__info__text']}>
                    <div className={styles['cards__content__info__text__label']}>
                      {card.name}
                    </div>

                    <div className={styles['cards__content__info__text__value']}>
                      {` MID: ${card.merchant_id}`}
                    </div>
                  </div>
                </div>

                <div className={styles['cards__content__trash']} onClick={() => handleOpenDeleteModal(card)}>
                  {TrashIcon}
                </div>
              </div>
            )
          })
        )}
      </div>

      <DeleteModal
        isOpen={isDeleteModalOpen}
        refetch={refetch}
        merchantName={selectedMerchant?.name}
        id={selectedMerchant?.merchant_id}
        onClose={handleCloseDeleteModal}
      />
    </>
  )
}
